import {
  Box,
  Collapse,
  Flex,
  HStack,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { AiFillPlusCircle } from "react-icons/ai";
import { BsChevronBarDown, BsChevronBarUp } from "react-icons/bs";
export default function Portfolio() {
  const [more, setMore] = React.useState(true);
  return (
    <Box border="1px solid #c5c5c5" borderRadius={10} overflow="hidden" my={8}>
      <Flex
        bg="#f1f1f1"
        justifyContent="space-between"
        p={4}
        fontWeight="medium"
        borderBottom={"1px"}
        borderColor="#c5c5c5"
      >
        <Text fontSize={{ base: "18px", md: "22px" }}>Portfolio</Text>
        <HStack
          gap={1}
          color="brand.500"
          sx={{ fontSize: { base: "13px", md: "18px" } }}
          cursor="pointer"
        >
          <AiFillPlusCircle />
          <Text>Add More</Text>
        </HStack>
      </Flex>
      <Collapse in={!more} startingHeight={"400px"}>
        <SimpleGrid columns={{ base: 1, md: 2 }} p={10} gap={10} >
          
          <Stack gap={5}>
            <Image src="/images/portfolio/1.png" />
            <Image src="/images/portfolio/2.png" />
            <Image src="/images/portfolio/3.png" />
          </Stack>
          <Stack gap={5}>
            <Image src="/images/portfolio/4.png" />
            <Image src="/images/portfolio/5.png" />
            <Image src="/images/portfolio/6.png" />
          </Stack>
        </SimpleGrid>
      </Collapse>
      <HStack
        color="brand.500"
        gap={2}
        py={10}
        justify={"center"}
        fontWeight={"medium"}
        fontSize={{ lg: "22px" }}
        cursor="pointer"
        onClick={() => {
          setMore(!more);
        }}
      >
        {more ? <BsChevronBarDown /> : <BsChevronBarUp />}
        <Text>See {more ? "More" : "Less"}</Text>
      </HStack>
    </Box>
  );
}
